<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Add Blocked CPR Numbers</h4>
        </div>
        <div class="card-body">
          <div class="row mb-4">
            <div class="col-md-12">
              <div class="alert alert-info">
                <p class="mb-0">You can add a single CPR number or multiple CPR numbers separated by commas.</p>
                <p class="mb-0">Example: 1234567890 or 1234567890,1234567891,1234567892</p>
              </div>
            </div>
          </div>
          
          <form [formGroup]="cprForm" (ngSubmit)="onSubmit()">
            <div class="row">
              <div class="col-md-12 mb-3">
                <label for="cprNumber" class="form-label">CPR Number(s)</label>
                <input 
                  type="text" 
                  class="form-control" 
                  id="cprNumber" 
                  formControlName="cprNumber" 
                  placeholder="Enter CPR number(s) separated by commas"
                  [ngClass]="{'is-invalid': cprForm.get('cprNumber')?.invalid && cprForm.get('cprNumber')?.touched}"
                >
                <div *ngIf="cprForm.get('cprNumber')?.invalid && cprForm.get('cprNumber')?.touched" class="invalid-feedback">
                  CPR number is required
                </div>
              </div>
              
              <div class="col-md-12 mb-3">
                <label for="reason" class="form-label">Reason (Optional)</label>
                <textarea 
                  class="form-control" 
                  id="reason" 
                  formControlName="reason" 
                  placeholder="Enter reason for blocking"
                  rows="3"
                ></textarea>
              </div>
            </div>
            
            <div *ngIf="success" class="alert alert-success mt-3">
              <p class="mb-0">CPR number(s) blocked successfully!</p>
              <p *ngIf="results" class="mb-0">Processed: {{results.total}}, Successfully blocked: {{results.success}}</p>
            </div>
            
            <div *ngIf="errors && errors.length > 0" class="alert alert-danger mt-3">
              <p class="mb-0">The following errors occurred:</p>
              <ul class="mb-0">
                <li *ngFor="let error of errors">{{ error }}</li>
              </ul>
            </div>
            
            <div class="row mt-4">
              <div class="col-md-12">
                <button type="submit" class="btn btn-primary me-2" [disabled]="cprForm.invalid || submitting">
                  <span *ngIf="submitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Block CPR Number(s)
                </button>
                <button type="button" class="btn btn-secondary" (click)="goBack()">Cancel</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div> 